(function () {

  'use strict';



  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var mobileSheetQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

  var fluidBackdrop = null;

  var openFluidMenus = new Set();

  var fluidListHomes = new WeakMap();

  var STAGE_LEAVE_MS = reducedMotion ? 0 : 120;



  function isMobileSheet() {
    // Keep filter menus as local dropdowns on all viewports.
    // (Previously used a mobile bottom sheet + full-screen blur backdrop.)
    return false;
  }



  function getFilterSelect(menu) {

    return menu.querySelector('select[data-mb-trust-moment-filter], select[data-mb-trust-review-filter]');

  }



  function getFilterList(menu) {

    if (menu && menu._mbTrustFilterList) return menu._mbTrustFilterList;

    return menu ? menu.querySelector('[data-mb-trust-filter-list]') : null;

  }



  function parkFilterList(menu, list) {

    if (!menu || !list || !isMobileSheet()) return;

    if (!fluidListHomes.has(list)) {

      fluidListHomes.set(list, { parent: list.parentNode, next: list.nextSibling });

    }

    list.classList.add('is-fluid-sheet');

    if (list.parentNode !== document.body) {

      document.body.appendChild(list);

    }

  }



  function restoreFilterList(list) {

    if (!list) return;

    list.classList.remove('is-open-sheet');

    list.classList.remove('is-fluid-sheet');

    var home = fluidListHomes.get(list);

    if (!home || !home.parent || !home.parent.isConnected) return;

    if (list.parentNode === home.parent) return;

    if (home.next && home.next.parentNode === home.parent) {

      home.parent.insertBefore(list, home.next);

    } else {

      home.parent.appendChild(list);

    }

  }



  function bindPressFeedback(el) {

    if (!el || el.dataset.mbPressReady) return;

    el.dataset.mbPressReady = '1';



    function pressOn() {

      el.classList.add('is-pressed');

    }



    function pressOff() {

      el.classList.remove('is-pressed');

    }



    el.addEventListener('pointerdown', pressOn);

    el.addEventListener('pointerup', pressOff);

    el.addEventListener('pointerleave', pressOff);

    el.addEventListener('pointercancel', pressOff);

  }



  function ensureFluidBackdrop() {

    if (fluidBackdrop) return fluidBackdrop;

    fluidBackdrop = document.createElement('button');

    fluidBackdrop.type = 'button';

    fluidBackdrop.className = 'mb-trust-fluid-backdrop';

    fluidBackdrop.setAttribute('aria-label', 'Close filter menu');

    fluidBackdrop.hidden = true;

    document.body.appendChild(fluidBackdrop);

    fluidBackdrop.addEventListener('click', function () {

      closeAllFluidMenus();

    });

    return fluidBackdrop;

  }



  function syncFluidBackdrop() {

    if (!isMobileSheet()) {

      if (fluidBackdrop) {

        fluidBackdrop.classList.remove('is-visible');

        fluidBackdrop.hidden = true;

      }

      return;

    }

    var backdrop = ensureFluidBackdrop();

    var hasOpen = openFluidMenus.size > 0;

    backdrop.hidden = !hasOpen;

    backdrop.classList.toggle('is-visible', hasOpen);

  }



  function closeFluidMenu(menu, immediate) {

    if (!menu) return;

    var trigger = menu.querySelector('[data-mb-trust-filter-trigger]');

    var list = getFilterList(menu);

    if (!trigger || !list) return;



    openFluidMenus.delete(menu);

    menu.classList.remove('is-open');

    trigger.setAttribute('aria-expanded', 'false');

    list.classList.remove('is-open-sheet');

    syncFluidBackdrop();



    function finishClose() {

      if (menu.classList.contains('is-open')) return;

      list.hidden = true;

      list.setAttribute('aria-hidden', 'true');

      restoreFilterList(list);

    }



    if (immediate || reducedMotion) {

      finishClose();

      return;

    }



    var onEnd = function (event) {

      if (event.target !== list || event.propertyName !== 'opacity') return;

      list.removeEventListener('transitionend', onEnd);

      finishClose();

    };



    list.addEventListener('transitionend', onEnd);

    window.setTimeout(function () {

      list.removeEventListener('transitionend', onEnd);

      finishClose();

    }, 320);

  }



  function closeAllFluidMenus(exceptMenu, immediate) {

    document.querySelectorAll('.mb-trust-moments-wrap [data-mb-trust-filter-menu].is-open, .mb-trust-reviews-wrap [data-mb-trust-filter-menu].is-open').forEach(function (menu) {

      if (exceptMenu && menu === exceptMenu) return;

      closeFluidMenu(menu, immediate);

    });

  }



  function openFluidMenu(menu) {

    var trigger = menu.querySelector('[data-mb-trust-filter-trigger]');

    var list = getFilterList(menu);

    if (!trigger || !list) return;



    closeAllFluidMenus(menu);

    list.hidden = false;

    list.setAttribute('aria-hidden', 'false');

    if (isMobileSheet()) {

      parkFilterList(menu, list);

    } else {

      restoreFilterList(list);

    }

    menu.classList.add('is-open');

    trigger.setAttribute('aria-expanded', 'true');

    openFluidMenus.add(menu);

    window.setTimeout(syncFluidBackdrop, 0);



    function revealSheet() {

      if (!menu.classList.contains('is-open')) return;

      list.classList.add('is-open-sheet');

    }



    if (isMobileSheet() && !reducedMotion) {

      window.requestAnimationFrame(function () {

        window.requestAnimationFrame(revealSheet);

      });

    } else {

      revealSheet();

    }

  }



  function initFilterMenus(root) {

    root.querySelectorAll('[data-mb-trust-filter-menu]').forEach(function (menu) {

      if (menu.dataset.mbFilterMenuReady) return;

      menu.dataset.mbFilterMenuReady = '1';



      var select = getFilterSelect(menu);

      var trigger = menu.querySelector('[data-mb-trust-filter-trigger]');

      var valueEl = menu.querySelector('.mb-trust-filter-menu__value');

      var list = menu.querySelector('[data-mb-trust-filter-list]');

      if (!select || !trigger || !valueEl || !list) return;

      menu._mbTrustFilterList = list;



      bindPressFeedback(trigger);



      list.innerHTML = '';

      Array.prototype.forEach.call(select.options, function (opt) {

        var item = document.createElement('li');

        item.className = 'mb-trust-filter-menu__option';

        item.setAttribute('role', 'option');

        item.tabIndex = -1;

        item.dataset.value = opt.value;

        item.textContent = opt.textContent;

        bindPressFeedback(item);

        list.appendChild(item);

      });



      function syncMenu() {

        var current = select.options[select.selectedIndex];

        valueEl.textContent = current ? current.textContent : '';

        trigger.classList.toggle('is-active', select.value !== 'all');

        Array.prototype.forEach.call(list.children, function (item) {

          var selected = item.dataset.value === select.value;

          item.classList.toggle('is-selected', selected);

          item.setAttribute('aria-selected', selected ? 'true' : 'false');

        });

      }



      function closeMenu() {

        closeFluidMenu(menu);

      }



      function openMenu() {

        openFluidMenu(menu);

      }



      trigger.addEventListener('click', function (event) {

        event.preventDefault();

        event.stopPropagation();

        if (menu.classList.contains('is-open')) closeMenu();

        else openMenu();

      });



      trigger.addEventListener('keydown', function (event) {

        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {

          event.preventDefault();

          openMenu();

          var selected = list.querySelector('.mb-trust-filter-menu__option.is-selected') || list.firstElementChild;

          if (selected) selected.focus();

        }

      });



      list.addEventListener('click', function (event) {

        event.stopPropagation();

        var option = event.target.closest('.mb-trust-filter-menu__option');

        if (!option) return;

        select.value = option.dataset.value;

        select.dispatchEvent(new Event('change', { bubbles: true }));

        syncMenu();

        closeMenu();

        trigger.focus();

      });



      list.addEventListener('keydown', function (event) {

        var items = Array.prototype.slice.call(list.querySelectorAll('.mb-trust-filter-menu__option'));

        var index = items.indexOf(document.activeElement);

        if (event.key === 'Escape') {

          event.preventDefault();

          closeMenu();

          trigger.focus();

        } else if (event.key === 'ArrowDown') {

          event.preventDefault();

          var next = items[Math.min(index + 1, items.length - 1)] || items[0];

          next.focus();

        } else if (event.key === 'ArrowUp') {

          event.preventDefault();

          var prev = items[Math.max(index - 1, 0)] || items[items.length - 1];

          prev.focus();

        } else if (event.key === 'Enter' || event.key === ' ') {

          event.preventDefault();

          var option = document.activeElement;

          if (!option || !option.dataset.value) return;

          select.value = option.dataset.value;

          select.dispatchEvent(new Event('change', { bubbles: true }));

          syncMenu();

          closeMenu();

          trigger.focus();

        }

      });



      document.addEventListener('click', function (event) {

        if (isMobileSheet()) return;

        if (!menu.classList.contains('is-open')) return;

        if (menu.contains(event.target) || list.contains(event.target)) {

          return;

        }

        closeMenu();

      });



      menu.syncFilterMenu = syncMenu;

      menu.closeFilterMenu = closeMenu;

      syncMenu();

    });

  }



  function resetFilterMenus(root) {

    root.querySelectorAll('[data-mb-trust-filter-menu]').forEach(function (menu) {

      var select = getFilterSelect(menu);

      if (select) select.value = 'all';

      if (typeof menu.syncFilterMenu === 'function') menu.syncFilterMenu();

      if (typeof menu.closeFilterMenu === 'function') menu.closeFilterMenu();

    });

  }



  function updatePlatformIndicator(root) {

    var container = root.querySelector('.mb-trust-platforms');

    var indicator = root.querySelector('[data-mb-trust-platform-indicator]');

    var active = container && container.querySelector('.mb-trust-platforms__tab.is-active, .mb-trust-platforms__tab[aria-selected="true"]');

    if (!container || !indicator || !active) return;



    var containerRect = container.getBoundingClientRect();

    var activeRect = active.getBoundingClientRect();

    indicator.style.width = activeRect.width + 'px';

    indicator.style.transform = 'translateX(' + (activeRect.left - containerRect.left) + 'px)';

  }



  function setEmptyState(empty, show) {

    if (!empty) return;

    if (reducedMotion) {

      empty.hidden = !show;

      empty.classList.toggle('is-visible', show);

      return;

    }



    if (show) {

      empty.hidden = false;

      window.requestAnimationFrame(function () {

        empty.classList.add('is-visible');

      });

      return;

    }



    empty.classList.remove('is-visible');

    window.setTimeout(function () {

      if (!empty.classList.contains('is-visible')) empty.hidden = true;

    }, 280);

  }



  function pulseCount(countEl) {

    if (!countEl || reducedMotion) return;

    countEl.classList.remove('is-updating');

    countEl.offsetHeight;

    countEl.classList.add('is-updating');

    window.setTimeout(function () {

      countEl.classList.remove('is-updating');

    }, 420);

  }



  function runStageTransition(panel, applyFn) {

    if (!panel || reducedMotion) {

      applyFn();

      return;

    }



    panel.classList.add('is-stage-leaving');

    window.setTimeout(function () {

      applyFn();

      panel.classList.remove('is-stage-leaving');

      panel.classList.add('is-stage-entering');

      window.requestAnimationFrame(function () {

        panel.classList.remove('is-stage-entering');

      });

    }, STAGE_LEAVE_MS);

  }



  function resolveVideoCover(url, platform) {
    if (!url) return Promise.resolve(null);

    var cacheKey = 'mb-moment-cover:' + url;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) return Promise.resolve(cached);
    } catch (e) {}

    function saveAndReturn(thumb) {
      if (thumb) {
        try { sessionStorage.setItem(cacheKey, thumb); } catch (e) {}
      }
      return thumb;
    }

    function fetchOembed(endpoint) {
      return fetch(endpoint, { credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data) return null;
          return data.thumbnail_url || data.thumbnail || null;
        })
        .catch(function () { return null; });
    }

    var noembed = 'https://noembed.com/embed?url=' + encodeURIComponent(url);
    var tiktokOembed = 'https://www.tiktok.com/oembed?url=' + encodeURIComponent(url);
    var chain = (platform === 'tiktok' || /tiktok\.com/i.test(url))
      ? fetchOembed(tiktokOembed).then(function (thumb) { return thumb || fetchOembed(noembed); })
      : fetchOembed(noembed);

    return chain.then(saveAndReturn);
  }

  function initMomentCovers(root) {
    if (!root) return;

    root.querySelectorAll('[data-mb-trust-moment-cover]').forEach(function (img) {
      if (img.dataset.coverLoaded === '1' || img.dataset.coverLoading === '1') return;
      if (img.closest('[hidden]')) return;
      if ((img.getAttribute('src') || '').indexOf('smr-cover-') !== -1) {
        img.dataset.coverLoaded = '1';
        img.classList.remove('is-cover-placeholder');
        return;
      }

      var url = img.getAttribute('data-video-url');
      if (!url) return;

      img.dataset.coverLoading = '1';
      resolveVideoCover(url, img.getAttribute('data-platform') || 'tiktok').then(function (thumb) {
        img.dataset.coverLoading = '0';
        if (!thumb) return;
        img.src = thumb;
        img.dataset.coverLoaded = '1';
        img.classList.remove('is-cover-placeholder');
      });
    });
  }

  function initPlatformTabs(root) {

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-platform]'));

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-moment]'));

    var count = root.querySelector('[data-mb-trust-moments-count]');

    var empty = root.querySelector('[data-mb-trust-moments-empty]');

    var grid = root.querySelector('[data-mb-trust-moments-grid]');

    var panel = root.querySelector('.mb-trust-moments__panel');

    var moreWrap = root.querySelector('[data-mb-trust-moments-more-wrap]');

    var moreBtn = root.querySelector('[data-mb-trust-moments-more]');

    var pageSize = parseInt(root.dataset.mbTrustMomentsLimit, 10) || 4;

    var filterLimit = parseInt(root.dataset.mbTrustMomentsFilterLimit, 10) || 2;

    var displayLimit = pageSize;

    if (!tabs.length) return;



    tabs.forEach(bindPressFeedback);



    if (empty && !empty.hidden) empty.classList.add('is-visible');



    var filters = {

      platform: tabs[0] ? (tabs[0].dataset.mbTrustPlatform || 'tiktok') : 'tiktok',

      contentType: 'all',

      product: 'all',

      concern: 'all',

      date: 'all',

      consent: 'all'

    };



    function cardMatches(card) {

      var isLiveCard = card.dataset.live === 'true';

      var platformOk = filters.platform === 'live'
        ? isLiveCard
        : !isLiveCard && (filters.platform === 'all' || card.dataset.platform === filters.platform);

      return platformOk

        && (filters.contentType === 'all' || card.dataset.contentType === filters.contentType)

        && (filters.product === 'all' || card.dataset.product === filters.product)

        && (filters.concern === 'all' || card.dataset.concern === filters.concern)

        && (filters.date === 'all' || card.dataset.dateBucket === filters.date)

        && (filters.consent === 'all' || card.dataset.consent === filters.consent);

    }



    function currentLimit() {
      var defaultPlatform = tabs[0] ? (tabs[0].dataset.mbTrustPlatform || 'tiktok') : 'tiktok';
      var filtered = filters.platform !== defaultPlatform
        || filters.contentType !== 'all'
        || filters.product !== 'all'
        || filters.concern !== 'all'
        || filters.date !== 'all'
        || filters.consent !== 'all';
      return filtered ? filterLimit : pageSize;
    }



    function applyPagination(matchedCards) {

      var shown = 0;

      displayLimit = currentLimit();

      // Home & Who: 4 cards by default, 2 after product/platform filters.
      cards.forEach(function (card) {
        card.hidden = true;
      });

      matchedCards.forEach(function (card, index) {
        if (index < displayLimit) {
          card.hidden = false;
          shown += 1;
        }
      });

      if (moreWrap) {
        moreWrap.hidden = true;
      }

      return shown;

    }



    var livePanel = root.querySelector('[data-mb-trust-live]');

    var filtersRow = root.querySelector('.mb-trust-moments__console-row--filters');

    var rail = root.querySelector('.mb-trust-moments__rail');

    function applyCore() {

      if (rail) rail.hidden = false;

      if (livePanel) livePanel.hidden = true;

      if (filtersRow) filtersRow.hidden = false;

      if (count) count.hidden = false;

      var matched = cards.filter(cardMatches);

      applyPagination(matched);



      if (count) {

        var countValue = count.querySelector('.mb-trust-filters__count-value');

        var countLabel = count.querySelector('.mb-trust-filters__count-label');

        var nextCount = String(matched.length);

        if (countValue && countValue.textContent !== nextCount) pulseCount(count);

        if (countValue) countValue.textContent = nextCount;

        if (countValue) countValue.textContent = nextCount;
        else if (!countLabel) count.textContent = nextCount;

      }



      setEmptyState(empty, matched.length === 0);

      if (grid) grid.hidden = matched.length === 0;

      initMomentCovers(root);

    }



    function apply(animate) {

      if (animate) runStageTransition(panel, applyCore);

      else applyCore();

    }



    function activateTab(tab, animate) {

      tabs.forEach(function (item) {

        var active = item === tab;

        item.classList.toggle('is-active', active);

        item.setAttribute('aria-selected', active ? 'true' : 'false');

        item.tabIndex = active ? 0 : -1;

      });

      filters.platform = tab.dataset.mbTrustPlatform || 'all';

      displayLimit = currentLimit();

      updatePlatformIndicator(root);

      apply(animate !== false);

    }



    tabs.forEach(function (tab, index) {

      tab.addEventListener('click', function () {

        activateTab(tab, true);

      });

      tab.addEventListener('keydown', function (event) {

        var nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;

        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;

        else if (event.key === 'Home') nextIndex = 0;

        else if (event.key === 'End') nextIndex = tabs.length - 1;

        else return;

        event.preventDefault();

        tabs[nextIndex].focus();

        activateTab(tabs[nextIndex], true);

      });

    });



    initFilterMenus(root);



    root.querySelectorAll('[data-mb-trust-moment-filter]').forEach(function (control) {

      control.addEventListener('change', function () {

        filters[control.dataset.mbTrustMomentFilter] = control.value;

        displayLimit = currentLimit();

        apply(true);

      });

    });



    var resetBtn = root.querySelector('[data-mb-trust-moments-reset]');

    if (resetBtn) {

      bindPressFeedback(resetBtn);

      resetBtn.addEventListener('click', function () {

        filters = {

          platform: tabs[0] ? (tabs[0].dataset.mbTrustPlatform || 'tiktok') : 'tiktok',

          contentType: 'all',

          product: 'all',

          concern: 'all',

          date: 'all',

          consent: 'all'

        };

        if (tabs[0]) activateTab(tabs[0], true);

        resetFilterMenus(root);

        root.querySelectorAll('[data-mb-trust-moment-filter]').forEach(function (control) {

          control.value = 'all';

        });

        displayLimit = currentLimit();

        apply(true);

      });

    }



    moreBtn?.addEventListener('click', function () {

      displayLimit = currentLimit();

      apply(true);

    });



    updatePlatformIndicator(root);

    window.addEventListener('resize', function () {

      updatePlatformIndicator(root);

      syncFluidBackdrop();

    }, { passive: true });



    if (mobileSheetQuery && mobileSheetQuery.addEventListener) {

      mobileSheetQuery.addEventListener('change', function () {

        closeAllFluidMenus(null, true);

        syncFluidBackdrop();

      });

    }



    apply(false);

  }



  function initReviewFilters(root) {

    initFilterMenus(root);



    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-review]'));

    var filters = { product: 'all', skinType: 'all', concern: 'all', rating: 'all', platform: 'all' };



    function apply() {

      if (!cards.length) return;

      cards.forEach(function (card) {

        var show = (filters.product === 'all' || card.dataset.product === filters.product)

          && (filters.skinType === 'all' || card.dataset.skinType === filters.skinType)

          && (filters.concern === 'all' || card.dataset.concern === filters.concern)

          && (filters.rating === 'all' || card.dataset.rating === filters.rating)

          && (filters.platform === 'all' || card.dataset.platform === filters.platform);

        card.hidden = !show;

      });

    }



    root.querySelectorAll('[data-mb-trust-review-filter]').forEach(function (control) {

      control.addEventListener('change', function () {

        filters[control.dataset.mbTrustReviewFilter] = control.value;

        apply();

      });

    });



    var resetBtn = root.querySelector('[data-mb-trust-reviews-reset]');

    if (resetBtn) {

      bindPressFeedback(resetBtn);

      resetBtn.addEventListener('click', function () {

        filters = { product: 'all', skinType: 'all', concern: 'all', rating: 'all' };

        root.querySelectorAll('[data-mb-trust-review-filter]').forEach(function (control) {

          control.value = 'all';

        });

        resetFilterMenus(root);

        apply();

      });

    }

  }



  function initEditorialTabs(root) {

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-editorial-tab]'));

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-editorial-card]'));

    if (!tabs.length) return;



    tabs.forEach(function (tab) {

      tab.addEventListener('click', function () {

        var tag = tab.dataset.mbTrustEditorialTab || 'all';

        tabs.forEach(function (item) { item.classList.toggle('is-active', item === tab); });

        cards.forEach(function (card) {

          var cardTags = (card.dataset.tags || card.dataset.tag || '').split(/\s+/);

          card.hidden = tag !== 'all' && cardTags.indexOf(tag) === -1;

        });

      });

    });

  }



  function syncFaqVisualHeight(root) {
    /* Editorial FAQ layout uses a fixed left image width; no height coupling. */
    var grid = root && root.querySelector('.mb-trust-faq__grid');
    if (grid) grid.style.removeProperty('--mb-faq-visual-height');
  }

  function initFaq(root) {
    var catButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-faq-cat]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mb-trust-faq-item]'));
    if (catButtons.length) {
      catButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cat = btn.dataset.mbTrustFaqCat || 'all';
          catButtons.forEach(function (item) { item.classList.toggle('is-active', item === btn); });
          items.forEach(function (item) {
            item.hidden = cat !== 'all' && item.dataset.category !== cat;
            if (item.hidden) {
              item.classList.remove('is-open');
              var trigger = item.querySelector('[data-mb-trust-faq-trigger]');
              if (trigger) trigger.setAttribute('aria-expanded', 'false');
            }
          });
        });
      });
    }

    root.querySelectorAll('[data-mb-trust-faq-trigger]').forEach(function (trigger) {
      bindPressFeedback(trigger);

      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-mb-trust-faq-item]');
        if (!item) return;

        var open = item.classList.contains('is-open');

        root.querySelectorAll('[data-mb-trust-faq-item].is-open').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            other.querySelector('[data-mb-trust-faq-trigger]')?.setAttribute('aria-expanded', 'false');
          }
        });

        item.classList.toggle('is-open', !open);
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        trigger.click();
      });
    });
  }



  function initVideoDialog(section) {

    var dialog = section.querySelector('[data-mb-trust-video-dialog]');

    var frame = dialog && dialog.querySelector('[data-mb-trust-video-frame]');

    var title = dialog && dialog.querySelector('[data-mb-trust-video-title]');

    var closeBtn = dialog && dialog.querySelector('[data-mb-trust-video-close]');

    if (!dialog || !frame) return;



    function closeDialog() {

      frame.replaceChildren();

      if (typeof dialog.close === 'function') dialog.close();

      else dialog.removeAttribute('open');

    }



    section.addEventListener('click', function (event) {

      var trigger = event.target.closest('[data-mb-trust-video-open]');

      if (!trigger) return;

      var videoId = trigger.dataset.videoId || '';

      if (!/^\d+$/.test(videoId)) return;

      var iframe = document.createElement('iframe');

      iframe.src = 'https://www.tiktok.com/player/v1/' + encodeURIComponent(videoId) + '?autoplay=1';

      iframe.title = trigger.dataset.title || 'Creator video';

      iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';

      iframe.allowFullscreen = true;

      frame.replaceChildren(iframe);

      if (title) title.textContent = trigger.dataset.title || 'Creator video';

      if (typeof dialog.showModal === 'function') dialog.showModal();

      else dialog.setAttribute('open', '');

    });



    closeBtn?.addEventListener('click', closeDialog);

    dialog.addEventListener('cancel', function (event) {

      event.preventDefault();

      closeDialog();

    });

    dialog.addEventListener('click', function (event) {

      if (event.target === dialog) closeDialog();

    });

  }



  document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('[data-mb-trust-moments]').forEach(function (root) {

      initPlatformTabs(root);

      initVideoDialog(root);

    });

    document.querySelectorAll('[data-mb-trust-reviews]').forEach(initReviewFilters);

    document.querySelectorAll('[data-mb-trust-editorial]').forEach(initEditorialTabs);

    document.querySelectorAll('[data-mb-trust-faq]').forEach(initFaq);

    document.querySelectorAll('[data-mb-trust-moments-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rail = btn.closest('.mb-trust-moments__rail');
        var grid = rail && rail.querySelector('[data-mb-trust-moments-grid]');
        if (!grid) return;
        grid.scrollBy({ left: Math.max(240, grid.clientWidth * 0.8), behavior: 'smooth' });
      });
    });

  });

})();


